import { useEffect } from 'react';
import { useSearchParams } from 'react-router-dom';
import { useTheme } from '../theme/ThemeContext';

/** Apply ?theme=light|dark from embed iframe URL on mount. */
export default function EmbedThemeInit() {
  const [searchParams] = useSearchParams();
  const { setTheme } = useTheme();

  useEffect(() => {
    const themeParam = searchParams.get('theme');
    if (themeParam === 'light' || themeParam === 'dark') {
      setTheme(themeParam);
    }
  }, [searchParams, setTheme]);

  return null;
}
